import type { BlendMode, GroupBlendMode } from '@/types/document'
import { locale } from '@/i18n'

const JA: Record<GroupBlendMode, string> = {
  'pass-through': '通過',
  normal: '通常',
  dissolve: 'ディザ合成',
  darken: '比較(暗)',
  multiply: '乗算',
  'color-burn': '焼き込みカラー',
  'linear-burn': '焼き込み(リニア)',
  'darker-color': 'カラー比較(暗)',
  lighten: '比較(明)',
  screen: 'スクリーン',
  'color-dodge': '覆い焼きカラー',
  'linear-dodge': '覆い焼き(リニア) - 加算',
  'lighter-color': 'カラー比較(明)',
  overlay: 'オーバーレイ',
  'soft-light': 'ソフトライト',
  'hard-light': 'ハードライト',
  'vivid-light': 'ビビッドライト',
  'linear-light': 'リニアライト',
  'pin-light': 'ピンライト',
  'hard-mix': 'ハードミックス',
  difference: '差の絶対値',
  exclusion: '除外',
  subtract: '減算',
  divide: '除算',
  hue: '色相',
  saturation: '彩度',
  color: 'カラー',
  luminosity: '輝度'
}

const EN: Record<GroupBlendMode, string> = {
  'pass-through': 'Pass Through',
  normal: 'Normal',
  dissolve: 'Dissolve',
  darken: 'Darken',
  multiply: 'Multiply',
  'color-burn': 'Color Burn',
  'linear-burn': 'Linear Burn',
  'darker-color': 'Darker Color',
  lighten: 'Lighten',
  screen: 'Screen',
  'color-dodge': 'Color Dodge',
  'linear-dodge': 'Linear Dodge (Add)',
  'lighter-color': 'Lighter Color',
  overlay: 'Overlay',
  'soft-light': 'Soft Light',
  'hard-light': 'Hard Light',
  'vivid-light': 'Vivid Light',
  'linear-light': 'Linear Light',
  'pin-light': 'Pin Light',
  'hard-mix': 'Hard Mix',
  difference: 'Difference',
  exclusion: 'Exclusion',
  subtract: 'Subtract',
  divide: 'Divide',
  hue: 'Hue',
  saturation: 'Saturation',
  color: 'Color',
  luminosity: 'Luminosity'
}

export function blendModeLabel(m: BlendMode | GroupBlendMode): string {
  return (locale.value === 'ja' ? JA : EN)[m]
}
